import { ChevronRight } from '@material-ui/icons';
import React from 'react';
import {
  ScheduleTableButton,
  ScheduleTableContainer,
  ScheduleTableIcon,
  ScheduleTableRightSide,
  ScheduleTableText,
} from './styles';

type Props = {
  id: string;
};

export default function ScheduleTable({ id }: Props) {
  return (
    <ScheduleTableContainer href={`https://booking.builderall.com/c/cliqueiachei/${id}`}>
      <ScheduleTableIcon src="/static/schedule-table-icon.svg" />
      <ScheduleTableRightSide>
        <ScheduleTableText>RESERVAR MESA</ScheduleTableText>
        <ScheduleTableButton>
          <ChevronRight style={{ color: '#fff' }} />
        </ScheduleTableButton>
      </ScheduleTableRightSide>
    </ScheduleTableContainer>
  );
}
